var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategoryHamper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4996 4C19.4996 5.93 17.9296 7.5 15.9996 7.5C15.5896 7.5 15.1996 7.42 14.8396 7.29L3.45961 18.66L1.33961 16.54L8.74961 9.13L6.96961 7.35L6.25961 8.06L4.84961 6.65V9.48L4.13961 10.19L0.599609 6.65L1.30961 5.94H4.12961L2.71961 4.53L6.25961 0.990003C7.42961 -0.179997 9.32961 -0.179997 10.4996 0.990003L8.37961 3.11L9.78961 4.52L9.07961 5.23L10.8596 7.01L12.7096 5.16C12.5796 4.8 12.4996 4.41 12.4996 4C12.4996 2.07 14.0696 0.500003 15.9996 0.500003C16.5796 0.500003 17.1196 0.660003 17.5996 0.910003L14.8996 3.61L16.3896 5.1L19.0896 2.4C19.3396 2.88 19.4996 3.42 19.4996 4ZM12.2822 12.6719L14.4035 10.5506L20.3997 16.5468L18.2784 18.6681L12.2822 12.6719Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4996 4C19.4996 5.93 17.9296 7.5 15.9996 7.5C15.5896 7.5 15.1996 7.42 14.8396 7.29L3.45961 18.66L1.33961 16.54L8.74961 9.13L6.96961 7.35L6.25961 8.06L4.84961 6.65V9.48L4.13961 10.19L0.599609 6.65L1.30961 5.94H4.12961L2.71961 4.53L6.25961 0.990003C7.42961 -0.179997 9.32961 -0.179997 10.4996 0.990003L8.37961 3.11L9.78961 4.52L9.07961 5.23L10.8596 7.01L12.7096 5.16C12.5796 4.8 12.4996 4.41 12.4996 4C12.4996 2.07 14.0696 0.500003 15.9996 0.500003C16.5796 0.500003 17.1196 0.660003 17.5996 0.910003L14.8996 3.61L16.3896 5.1L19.0896 2.4C19.3396 2.88 19.4996 3.42 19.4996 4ZM12.2822 12.6719L14.4035 10.5506L20.3997 16.5468L18.2784 18.6681L12.2822 12.6719Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryHamper);
export default __webpack_public_path__ + "static/media/iconCategoryHamper.13384c65d313cd82c2d1ebbed33e002d.svg";
export { ForwardRef as ReactComponent };